import api from './api';
import { Pricing, PricingType } from '../types';

export const pricingService = {
  getAll: async (type?: PricingType): Promise<Pricing[]> => {
    const params = type ? { type } : {};
    const response = await api.get('/pricing', { params });
    return response.data;
  },

  getByProvider: async (providerId: string): Promise<Pricing[]> => {
    const response = await api.get(`/pricing/provider/${providerId}`);
    return response.data;
  },

  getByCustomer: async (customerId: string): Promise<Pricing[]> => {
    const response = await api.get(`/pricing/customer/${customerId}`);
    return response.data;
  },

  getById: async (id: string): Promise<Pricing> => {
    const response = await api.get(`/pricing/${id}`);
    return response.data;
  },

  lookupPrice: async (
    type: PricingType,
    entityId: string,
    pickupLocation: string,
    dropoffLocation: string,
    vehicleTypeId?: string,
    direction?: string,
  ): Promise<Pricing | null> => {
    const params: Record<string, string> = { type, entityId, pickupLocation, dropoffLocation };
    if (vehicleTypeId) params.vehicleTypeId = vehicleTypeId;
    if (direction) params.direction = direction;
    const response = await api.get('/pricing/lookup', { params });
    return response.data;
  },

  create: async (data: Partial<Pricing>): Promise<Pricing> => {
    const response = await api.post('/pricing', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Pricing>): Promise<Pricing> => {
    const response = await api.patch(`/pricing/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/pricing/${id}`);
  },
};
